import { useNavigate } from "react-router-dom";
import { KionButton } from "../../button/button"
import s from './styles.module.scss'

export function KionSuccess() {
  const navigate = useNavigate();

  function moveTo(link: string) {
    window.location.assign(link)
  }

  return (
    <div style={{
      background: '#090B3F',
      height: '100vh',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    }}>
      <div className={s.wrapper}>
        <h2 className={s.title}>
            <div className={s.icon}>
              <img src="/images/done-icon.svg"/>
            </div>
            Подписка успешно подключена!
        </h2>
        <div className={s.subtitle}>
			<div className={s.label}>Теперь вы можете перейти на сайт кинотеатра или установить наше приложение</div>
        </div>

		<div className={s['btn-block']}>
			<KionButton onClick={() => moveTo('https://kion.ru')}>
				Перейти на kion.ru
			</KionButton>
			<KionButton onClick={() => navigate({ pathname: "/" })}>
				Назад
			</KionButton>
		</div>

        <div className={s['app-ref-row']}>
            <img src="/images/appstores//google-play.svg"
                onClick={() => moveTo('https://play.google.com/store/apps/details?id=ru.mts.mtstv')}/>
            <img src="/images/appstores//app-store.svg"
                onClick={() => moveTo('https://apps.apple.com/ru/app/id1451612172')}/>
            <img src="/images/appstores//app-gallery.svg"
                onClick={() => moveTo('https://appgallery.huawei.com/#/app/C101183499')}/>
        </div>
      </div>
    </div>
  )
}
